import { ControlFacet } from '../models/controls/ControlFacet';

/**
 * This is the items view search control
 * getSearchItemKey returns a key facet for the item to lookup
 * isAvailable is a boolean that returns true if search exists for the addon
 * itemKey represent the current key and will be updated by getSearchItemKey
 * itemsScopeItemKey is the key to the current item scope
 */
export const itemsViewSearchControl = new ControlFacet<{
  itemKey: string | undefined;
}, {
    isAvailable: boolean;
    getSearchItemKey: (query: string | undefined) => string | undefined;
  }>('itemsViewSearchControl');
